import { Box, Display, FlexDirection } from '@gousto-internal/citrus-react'
import Immutable from 'immutable'
import React from 'react'
import { useSelector } from 'react-redux'
import { CuratedBoxRecipe } from './Components/CuratedBoxRecipeTile/CuratedBoxRecipeTile'
import { CuratedBoxesRecipesType, getCuratedBoxesRecipes } from './utils/getCuratedBoxesRecipes'

type CuratedBoxLayoutProps = {
  curatedBoxesMethods: {
    getRecipes: () => Immutable.Map<string, string>
    getNumPortions: () => 1 | 2 | 3 | 4 | 5
    getRecipeStock: {
      isRecipeOutOfStock: (id: string) => boolean
    }
    getCuratedBoxes: () => CuratedBoxesRecipesType
  }
  handleOnClickForCuratedBox: () => void
}

export const CuratedBoxLayout = ({
  curatedBoxesMethods,
  handleOnClickForCuratedBox,
}: CuratedBoxLayoutProps) => {
  const { isRecipeOutOfStock } = curatedBoxesMethods.getRecipeStock
  const allRecipes = useSelector(curatedBoxesMethods.getRecipes)
  const numPortions = useSelector(curatedBoxesMethods.getNumPortions)

  const curatedBoxesRecipes = useSelector(curatedBoxesMethods.getCuratedBoxes)
  const recipesToJS = allRecipes.toJS()
  const curatedBoxesData = getCuratedBoxesRecipes(
    recipesToJS,
    curatedBoxesRecipes,
    isRecipeOutOfStock,
    numPortions,
  )

  return (
    <Box>
      {!!curatedBoxesData.length && (
        <Box
          display={Display.Flex}
          flexDirection={[FlexDirection.Column, null, FlexDirection.Row]}
          wrap
        >
          {curatedBoxesData.map((curatedBoxData) => (
            <Box
              paddingH={2}
              paddingV={2}
              key={curatedBoxData.id}
              width={['100%', null, '50%', '33%', '33%']}
            >
              <CuratedBoxRecipe
                index={1}
                curatedBoxData={curatedBoxData}
                handleOnClick={handleOnClickForCuratedBox}
                numPortions={numPortions}
              />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  )
}
